// import { TConsumptionGenerationItem, TGetConsumptionGenerationParams } from "../types";

import { 
	FetchCouponsResponse, 
	ValidateCouponResponse,
	ApplyCouponResponse,
	ApplyCouponData,
	ValidateCouponData,
	ApplyCouponAPIData
 } from "@/components/form-fields/CouponField/types/coupons";
import API from "../../../../services/api";
import { IPublicityBannerProps } from "@gisce/oficina-virtual-components";
import { isCoupon } from "@/types/models/guards";

export enum Endpoints {
	FetchCoupons = '/user/coupons',
	ValidateCoupon = '/coupons/validate/:coupon/',
	ApplyCoupon = '/coupons/apply/:coupon/',
}

const fetchCoupons = (lang: string) => {

	const parseCoupon = (coupon: FetchCouponsResponse[0]) => {
		const parsedCoupon: IPublicityBannerProps["dataProps"] = {
			shareURL: coupon.code_url,
			title: coupon.campaign.name,
			description: coupon.campaign.description,
			infoURL: coupon.campaign.url,
		}
		return parsedCoupon;
	}

	return new Promise<IPublicityBannerProps["dataProps"][]>(async (resolve, reject) => {
		API.get<FetchCouponsResponse>({
			endpoint: Endpoints.FetchCoupons,
			config: {
				lang
			}
		})
		.then(res => {
			// Typeguard
			try {
				resolve(
					res.promise.data.map(coupon => !isCoupon(coupon) ? parseCoupon(coupon) : coupon)
				);
			} catch (err) {
				reject(err);
			}
		})
		.catch(err => {
			reject(err);
		})
	})
}

const validateCoupon = ({coupon, association}: ValidateCouponData) => {

	return API.get<ValidateCouponResponse>({
		endpoint: Endpoints.ValidateCoupon,
		searchParams: [
			association ? `?associationId=${association.id}` : '',
			association ? `&associationType=${association.type}` : '',
		].join(''),
		params: {
			coupon
		}
	})
	.then(res => {
		return res.promise.data.valid;
	})
	.catch(err => {
		return false;
	})
}


const applyCoupon = (data: ApplyCouponData) => {

	return new Promise<ApplyCouponResponse>(async (resolve, reject) => {
		API.post<ApplyCouponResponse, ApplyCouponAPIData>({
			endpoint: Endpoints.ApplyCoupon,
			params: {
				coupon: data.coupon
			},
			data: {
				associationType: data.association.type,
				associationId: data.association.id
			}
		})
		.then(res => {
			resolve(res.promise.data);
		})
		.catch(err => {
			reject(err);
		})
	})
}

export default {
	fetchCoupons,
	validateCoupon,
	applyCoupon
};